<template>
	<div>
		<v-dialog v-model="dialog_product" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">
						{{$parent.Form.productData.items.length && $parent.Form.productData.items[0].groupId ? 'Edit Item' : 'Add Item'}}
					</v-toolbar-title>

				    <v-spacer></v-spacer>

				    <v-btn icon dark-opacity-color flat @click="$parent.fn_removeItem(null)" v-if="$parent.Form.productData.items.length && $parent.Form.productData.items[0].groupId"><v-icon class="redcolor">delete</v-icon></v-btn>

				    <!-- <v-btn round-borders outline :disabled="disableBtn" @click="fn_checkValidations()">Done</v-btn> -->

				</v-toolbar>

        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width class="hasBigFooter">

        	  			<v-layout wrap padding-top-bottom-ten white-background>

							<v-flex xs12 sm12 md12 align-msg-right form-item
					        	@click="fn_openProducts">

				               <v-text-field  
					               	readonly
					               	:disabled="disableBtn || $parent.Form.productDataModel.fromScanner"
					               	v-model="$parent.Form.productData.productName" 
					               	:hide-details="summaryArray.length ? true : false"
					               	label="Item" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	:onUpdate="fn_updateProduct"
					               	ref="ref_dialogProduct_productName"
					               	v-validate="'required'" 
				               		data-vv-name="item" 
				               		:error-messages="errors.collect('fields.item')"
				               		required>
				               </v-text-field>

							   <!-- <div custom-message v-if="$parent.Form.productDataModel.purchaseRate">
				               		Purchase Rate (&#8377;): {{ $parent.Form.productDataModel.purchaseRate }}
				               </div> -->

							   <v-layout row wrap light-opacity-color pt-2>
									<v-flex xs6 sm6 md6>
										<div v-if="$parent.Form.productDataModel.purchaseRate">
											Purchase Rate: &#8377;{{ $root.numberToLocale($parent.Form.productDataModel.purchaseRate) }}
										</div>
									</v-flex>

									<v-flex xs6 sm6 md6 right-align>
										<div v-if="summaryArray.length">
											Stock: 
											<span v-for="(item, index) in summaryArray" :key="index">
												<span :class="{'redcolor':item.qty<0}">{{item.roundOffQty != undefined ? item.roundOffQty : roundUpto2Decimals(item.qty)}} {{item.unitName}}<span v-if="index != summaryArray.length - 1">, </span> </span>
											</span>
										</div>
									</v-flex>
							   </v-layout>

				               <!-- <div custom-message :class="{'pt-0':$parent.Form.productDataModel.purchaseRate}" v-if="summaryArray.length">
				               		<span v-for="(item, index) in summaryArray" :key="index">
				               			Stock: <span :class="{'redcolor':item.qty<0}">{{item.qty}} {{item.unitName}}</span>
				               		</span>
				               </div> -->
				            </v-flex>

						</v-layout>


						<div margin-top-ten v-for="(product, itemIndex) in $parent.Form.productData.items" :key="itemIndex">

							<!-- <v-expansion-panel margin-top-ten>
							    <v-expansion-panel-content :value="$parent.Form.productData.items.length==1 ? true : false"> -->
							    	
							    	<!-- <v-subheader slot="header" nopadding>
							    		<span font-small>
							    			<span v-if="$root.TransactionSettings.mrpWiseStock">
							    				MRP: &#8377; <span v-if="product.mrp">{{product.mrp ? $root.numberToLocale(product.mrp) : 0}}</span>,&nbsp;
							    			</span>
							    			<span>
							    				Rate: &#8377; <span v-if="product.rate">{{$root.numberToLocale(product.rate)}}</span>,&nbsp;
							    			</span>
							    			<span>
							    				Net Amount: &#8377; <span v-if="product.netAmount">{{product.netAmount ? $root.numberToLocale(product.netAmount) : 0}}</span>
							    			</span>
							    		</span>
							    	</v-subheader> -->
							    	
							    	<v-layout row wrap padding-top-ten white-background v-if="$parent.Form.productData.productName">
										<!-- <v-flex xs6 sm6 md6 pr-2 pl-3 v-if="product.groupTypeId == 101 && $root.TransactionSettings.mrpWiseStock">
								           	<v-text-field 
								           		:disabled="disableBtn"
								           		v-model.number="product.mrp"
								           		label="MRP" 
								           		placeholder=" "
								           		type="number"
								           		v-validate="'min_value:0|decimal:2'" 
							               		data-vv-name="mrp" 
							               		:error-messages="errors.collect('fields.mrp')">
								           	</v-text-field>
								        </v-flex> -->

										<!-- v-if="!$parent.Form.productData.items[0].batches || !$parent.Form.productData.items[0].batches.length" -->
								        <v-layout row wrap v-for="(item, vIndex) in product.productVariants" :key="vIndex">
								        	<v-flex xs6 sm6 md6 pr-2 pl-3>
									           	<!-- <v-text-field 
									           		:disabled="disableBtn"
									           		v-model.number="item.qty"
									           		:hint="item.billQty != undefined ? 'Bill Qty: ' + item.billQty : ''"
									           		persistent-hint
									           		@input="fn_checkInput(item)"
									           		label="Quantity" 
									           		placeholder="1"
									           		type="number"
									           		v-validate="'numeric|max:8'" 
								               		:data-vv-name="item.unitName+vIndex" 
								               		data-vv-as="quantity"
								               		:error-messages="errors.collect('fields.'+item.unitName+vIndex)">
									           	</v-text-field> -->
												<!-- :hint="item.billQty != undefined ? 'Bill Qty: ' + fn_getBillQty(item) : ''" -->
												<v-text-field 
									           		v-model="item.qty"
													:disabled="disableBtn || ($parent.Form.productData.items[0].batches && $parent.Form.productData.items[0].batches.length) ? true : false"
									           		:hint="fn_getBillQty(item)"
									           		persistent-hint
													@input="fn_changeProductQty(item)"
									           		label="Quantity" 
									           		placeholder="1"
									           		type="number">
									           	</v-text-field>
									        </v-flex>
											<!-- @input="$root.fn_boundDecimalLength(item, fn_checkInput, 'qty')" -->
									        <v-flex xs6 sm6 md6 pr-3 pl-2>
									           	<v-text-field 
													v-if="!item.secondaryUnitId"
									           		:disabled="true"
									           		:value="fn_getLabel(item)"
									           		label="Unit"
									           		placeholder=" ">
									           	</v-text-field>

												<v-select
													v-else
													:items="[{itemId:item.primaryUnitId, itemName:item.primaryUnitName}, {itemId:item.secondaryUnitId, itemName:item.secondaryUnitName}]"
													label="Unit"
													:disabled="$parent.Form.selectedBatchType == 2 && $parent.Form.productData.items[0].batches && $parent.Form.productData.items[0].batches.length"
													item-text="itemName"
			          								item-value="itemId"
													v-model="item.selectedUnit"
													:hide-details="true"
													return-object
													ref="ref_unitSelection"
													@change="fn_unitChange($event, item, product)"
												></v-select>

												<div class="pb-2 pt-1 right-align" v-if="item.secondaryUnitId">{{ item.packQuantity }} {{ item.primaryUnitName }} = {{ item.secondaryUnitPackQuantity }} {{ item.secondaryUnitName }}</div>
												<!-- do not remove using this to display selected unit in batch items -->
												<div style="display: none;">{{ item }}</div>
											</v-flex>

											<div redcolor class="pl-3 pb-3" full-width v-if="product.groupTypeId == 101 && summaryArray && summaryArray.length && (!summaryArray[0].qty || getSummaryQuantity(item) < item.qty)">
												<v-icon style="color: red !important;" font16 class="mr-1">info_outline</v-icon>
												
												<!-- {{ summaryArray[0].unitId }} {{ item.unitId }}
												<template v-if="summaryArray[0].unitId == item.unitId">
													<span v-if="(Math.round(summaryArray[0].qty * item.secondaryUnitPackQuantity)) <= 0">Item is out of stock</span>
													<span v-else>Only {{ Math.round(summaryArray[0].qty * item.secondaryUnitPackQuantity) }} {{ item.secondaryUnitId ? item.secondaryUnitName : item.unitName }} {{ (Math.round(summaryArray[0].qty * item.secondaryUnitPackQuantity)) > 1 ? 'are' : 'is' }} in stock.</span>
												</template>

												<template v-else>
													<span v-if="summaryArray[0].qty <= 0">Item is out of stock</span>
													<span v-else>Only {{ summaryArray[0].qty }} {{ fn_getLabel(item) }} {{ summaryArray[0].qty > 1 ? 'are' : 'is' }} in stock.</span>
												</template> -->
												<span v-if="summaryArray[0].qty <= 0">Item is out of stock</span>
												<!-- <span v-else>Only {{ summaryArray[0].qty }} {{ fn_getLabel(item) }} {{ summaryArray[0].qty > 1 ? 'are' : 'is' }} in stock.</span> -->
												<span v-else>
													<template v-if="!item.secondaryUnitId">
														<template v-if="summaryArray[0].roundOffQty != undefined">
															Only {{ summaryArray[0].roundOffQty }} {{ fn_getLabel(item) }} {{ summaryArray[0].roundOffQty > 1 ? 'are' : 'is' }} in stock.
														</template>
														<template v-else>
															Only {{ roundUpto2Decimals(summaryArray[0].qty) }} {{ fn_getLabel(item) }} {{ summaryArray[0].qty > 1 ? 'are' : 'is' }} in stock.
														</template>
														<!-- Only {{ roundUpto2Decimals(summaryArray[0].roundOffQty != undefined ? summaryArray[0].roundOffQty : summaryArray[0].qty) }} {{ fn_getLabel(item) }} {{ summaryArray[0].qty > 1 ? 'are' : 'is' }} in stock. -->
													</template>
													<template v-else>
														Only {{ item.selectedUnit.itemId == item.primaryUnitId ? roundUpto2Decimals(summaryArray[0].qty) : roundUpto2Decimals((summaryArray[0].qty * item.secondaryUnitPackQuantity) / item.packQuantity) }} {{ item.selectedUnit.itemName }} {{ summaryArray[0].qty > 1 ? 'are' : 'is' }} in stock.
													</template>
												</span>
											</div>
								        </v-layout>

										<v-flex xs6 sm6 md6 pr-2 pl-3 v-if="product.groupTypeId == 101 && $root.TransactionSettings.mrpWiseStock">
								           	<v-text-field 
								           		:disabled="disableBtn"
								           		v-model.number="product.mrp"
								           		label="MRP" 
								           		placeholder=" "
								           		type="number"
								           		v-validate="'min_value:0|decimal:2'" 
							               		data-vv-name="mrp" 
							               		:error-messages="errors.collect('fields.mrp')">
								           	</v-text-field>
								        </v-flex>

										<v-flex :class="[product.groupTypeId == 102 || !$root.TransactionSettings.mrpWiseStock ? 'xs12 sm12 md12 pr-3 pl-3' : 'xs6 sm6 md6 pr-3 pl-2']">
								           	<v-text-field 
								           		:disabled="disableBtn"
								           		v-model.number="product.rate"
								           		:label="product.groupTypeId == 102 ? 'Amount' : product.productVariants[0].secondaryUnitId ? 'Rate (Per ' + product.productVariants[0].selectedUnit.itemName + ')' : 'Rate (Per ' + product.productVariants[0].unitName + ')'"
								           		placeholder=" "
								           		type="number"
								           		v-validate="'min_value:0|decimal:4'" 
							               		data-vv-name="rate" 
							               		:error-messages="errors.collect('fields.rate')">
								           	</v-text-field>	

											<div right-align font12 v-if="$parent.Form.productDataModel.defaultRate && $parent.Form.partyWiseItemRate && product.rate != $parent.Form.productDataModel.defaultRate">Default Rate: {{ $parent.Form.productDataModel.defaultRate }} <v-icon @click="product.rate = $parent.Form.productDataModel.defaultRate">autorenew</v-icon></div>
											<!-- <div v-if="$parent.Form.partyWiseItemRate && $parent.Form.partyWiseItemRate == item.rate && item.rate">Default Rate: {{ $parent.Form.partyWiseItemRate }} <v-icon @click="product.rate = $parent.Form.partyWiseItemRate">refresh</v-icon></div> -->
								        <!-- {{product.rate}}
										{{ $parent.Form.partyWiseItemRate }}
										{{ $parent.Form.productDataModel.items[0].rate }} -->
										</v-flex>
										

										<div full-width v-if="$parent.Form.dynamicItemSection && $parent.Form.dynamicItemSection.length">
											<component-dynamic-fields ref="ref_componentDynamicFields" :openAccountLedgers="$parent.fn_openAccountLedgers" :openListItems="$parent.fn_openListItems" :openDatePicker="$parent.fn_openDatePicker" :dynamicFields="product.customFields"></component-dynamic-fields>
										</div>

										<div class="pt-2 pb-2 grey-back full-width" v-if="$parent.toolbarTitle != 'Credit Note' && $parent.settings.transactionTypeId != 10001 && $parent.settings.transactionTypeId != 10005">
											<template v-if="hasSeries && !hasOnlySeries && $root.TransactionSettings.enableBatch">
												<v-radio-group class="pt-3 pl-3 pr-3 pb-1" white-background hide-details v-model="$parent.Form.selectedBatchType" row @change="fn_changeBatchType($event, product)">
													<v-radio label="Batch" :value="1"></v-radio>
													<v-radio label="Series" :value="2"></v-radio>
												</v-radio-group>
												<v-divider></v-divider>
											</template>

											<v-subheader class="white-background" v-if="$root.TransactionSettings.enableBatch || (!$parent.Form.isNew && $parent.Form.productData.items && $parent.Form.productData.items.length && $parent.Form.productData.items[0].batches && $parent.Form.productData.items[0].batches.length)">
												<!-- {{ seriesFields }} -->
												<template v-if="$parent.Form.selectedBatchType == 2"><span v-for="(field, index) in seriesFields" :key="field.title">{{ field.title }}<span v-if="seriesFields.length - 1 != index">/</span></span></template>
												<template v-else>Batches</template>
												 <v-spacer></v-spacer> 
												<!-- <v-btn color="primary" capitalize class="mr-0" @click="fn_openDialogSelectBatch">Select/Add</v-btn>  -->
												
												<template v-if="$root.TransactionSettings.enableBatch">
													<v-btn v-if="product.baseTransactionListId == 10003 && $parent.settings.transactionTypeId == 10004" small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_openDialogReturnForm('ref_dialogReturnForm')">
														<v-icon class="mr-1" font16 color="primary">edit</v-icon> Change Batch Quantity
													</v-btn>

													<v-btn v-else small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="fn_openDialogSelectBatch">
														<v-icon class="mr-1" font16 color="primary">add</v-icon> Add / Select
													</v-btn>
												</template>
												<!-- <v-btn color="primary"  capitalize flat class="mr-0" @click="fn_newBatch">New Batch <v-icon color="primary" class="ml-1">add</v-icon></v-btn> -->
											</v-subheader>
											<template v-if="$parent.Form.productData.items.length">
												<v-card flat v-for="(batch, batchIndex) in $parent.Form.productData.items[0].batches" :key="batchIndex" v-if="fn_showHideBatches(batch)">
													<v-divider></v-divider>
													<v-card-text class="pb-2">
														<div style="float: left;margin-right: 12px;" v-if="(product.baseTransactionListId != 10003 && $parent.settings.transactionTypeId == 10004) || $parent.settings.transactionTypeId == 10002 || $parent.settings.transactionTypeId == 10003">
															<v-btn small nomargin icon flat @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
														</div>
														<v-layout class="batch_layout" row wrap>
															<!-- <v-flex xs4 sm4 md4 mb-2 v-for="(field, fieldIndex) in $root.TransactionSettings.batchFields" :key="fieldIndex" v-if="field.id != 'opening' && $parent.fn_fieldVisibilty(field, $parent.Form.selectedBatchType)">
																<div light-opacity-color>{{ field.title }}</div>
																<div v-if="field.type == 'date'">{{ batch[field.id] | moment('DD-MMM-YYYY') }}</div>
                                    							<div v-else>{{ batch[field.id] }}</div>
															</v-flex> -->
															<!-- <v-flex xs2 sm2 md2 mb-2 v-if="(product.baseTransactionListId != 10003 && $parent.settings.transactionTypeId == 10004) || $parent.settings.transactionTypeId == 10002 || $parent.settings.transactionTypeId == 10003">
																<v-btn small nomargin icon flat @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
															</v-flex> -->
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
																<div light-opacity-color>Batch No.</div>
																<div>{{ batch.batchNumber }}</div>
															</v-flex>
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
																<div light-opacity-color>Size</div>
																<div>{{ batch.batchSize }}</div>
															</v-flex>
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
																<div light-opacity-color>MRP</div>
																<div>{{ batch.batchMRP }}</div>
															</v-flex>
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
																<div light-opacity-color>Mfg. Date</div>
																<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
															</v-flex>
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
																<div light-opacity-color>Exp. Date</div>
																<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
															</v-flex>
															<!-- <v-flex xs4 sm4 md4 mb-2>
																<div light-opacity-color>Opening</div>
																<div>{{ batch.opening ? batch.opening : 0  }}</div>
															</v-flex> -->
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
																<div light-opacity-color>Purchase Rate</div>
																<div>{{ batch.purchaseRate }}</div>
															</v-flex>
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
																<div light-opacity-color>Serial Number</div>
																<div>{{ batch.field1 }}</div>
															</v-flex>
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
																<div light-opacity-color>IMEI Number</div>
																<div>{{ batch.field2 }}</div>
															</v-flex>
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
																<div light-opacity-color>Part Number</div>
																<div>{{ batch.field3 }}</div>
															</v-flex>
															<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
																<div light-opacity-color>Model Number</div>
																<div>{{ batch.field4 }}</div>
															</v-flex>
															<!-- <v-flex xs4 sm4 md4 mb-2>
																<div light-opacity-color>Quantity</div>
																<div>{{ batch.qty }}</div>
															</v-flex> -->
														</v-layout>

														<v-layout row wrap :style="{'paddingLeft':product.baseTransactionListId == 10003 && $parent.settings.transactionTypeId == 10004 ? '0px' : '40px'}" v-if="$parent.Form.selectedBatchType == 1">
															<!-- <v-flex xs4 sm4 md4 pr-2 :class="{'error_background':batch.currentStock<0}">
																<v-text-field
																	readonly
																	:error="batch.currentStock<0"
																	label="Stock"
																	:value="batch.currentStock ? batch.currentStock : 0"
																	placeholder=" "
																></v-text-field>
															</v-flex> -->
															<v-flex xs6 sm6 md6>
																<v-text-field
																	label="Quantity"
																	:disabled="(product.baseTransactionListId == 10003 && $parent.settings.transactionTypeId == 10004) || !$root.TransactionSettings.enableBatch"
																	v-model.number="batch.productQty"
																	:hint="batch.billQty != undefined ? 'Bill Qty: ' + batch.billQty : ''"
																	@input="fn_changeBatchQty(batch)"
																	type="number"
																	placeholder=" "
																	v-validate="'min_value:0'" 
																	data-vv-name="qty" 
																	:hide-details="!errors.has('fields.qty') || !batch.billQty"
																	:error-messages="errors.collect('fields.qty')"
																></v-text-field>
															</v-flex>
															
															<v-flex xs6 sm6 md6 pl-3>
																<v-text-field
																	label="Unit"
																	:disabled="true"
																	:hide-details="!errors.has('fields.qty')"
																	:value="$parent.Form.productData.items[0].productVariants[0].selectedUnit ? $parent.Form.productData.items[0].productVariants[0].selectedUnit.itemName : $parent.Form.productData.items[0].productVariants[0].unitName"
																></v-text-field>
															</v-flex>

															<v-flex xs12 sm12 md12 pt-1 pb-1 pr-2 right-align :class="{'error_background redcolor':batch.currentStock<0}">
																Current Stock: {{ batch.currentStock ? roundUpto2Decimals(batch.currentStock) : 0 }} {{ $parent.Form.productData.items[0].productVariants[0].primaryUnitName }}
															</v-flex>

															<v-flex xs12 sm12 md12 redcolor pb-2 pt-2 v-if="batch.expDate && $parent.fn_checkDate(batch)">
																<v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ $parent.fn_getDate(batch) }}
															</v-flex>
														</v-layout>
													</v-card-text>
												</v-card>
												
											</template>

											<!-- <v-list two-line nopadding v-if="$parent.Form.productData.items.length">
												<v-list-tile v-for="(batch, batchIndex) in $parent.Form.productData.items[0].batches" :key="batchIndex">
													<v-list-tile-content>
														<v-list-tile-sub-title>Batch Number: {{batch.batchNumber}}</v-list-tile-sub-title>
														<v-list-tile-sub-title>Qty: {{batch.productQty}} {{ fn_getLabel($parent.Form.productData.items[0].productVariants[0]) }}</v-list-tile-sub-title>
													</v-list-tile-content>
													<v-list-tile-action>
														<v-btn flat icon @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
													</v-list-tile-action>
												</v-list-tile>
											</v-list> -->
										</div>

								        <!-- <v-flex xs12 sm12 md12 form-item v-if="product.groupTypeId == 102">
								           	<v-textarea 
							               		rows="2" 
							               		:disabled="disableBtn"
							               		v-model="product.description"
							               		placeholder=" " 
							               		label="Description"
							               		:counter="120"
							               		v-validate="'max:120'"
							               		data-vv-name="description" 
							               		:error-messages="errors.collect('fields.description')">
						               		</v-textarea>
								        </v-flex> -->

									</v-layout>

							        <div white-background v-if="product.addOnsItems.length">
							        	<!-- <v-subheader>Discounts/Taxes/Other Charges</v-subheader> -->
								        <v-layout row wrap padding-top-ten v-for="(item, index) in product.addOnsItems" :key="index" v-if="!item.isGst">

								        	<v-layout row wrap v-if="item.mode==0">
								        		<v-flex xs6 sm6 md6 pr-2 pl-3>
										           	<v-text-field 
										           		:disabled="disableBtn"
										           		suffix="%"
										           		v-model.number="item.percentage"
										           		@input="fn_checkPercentage(item)"
										           		:label="item.name"
										           		placeholder=" "
										           		type="number"
										           		v-validate="'min_value:0|decimal:2'" 
									               		:data-vv-name="'percent'+index" 
									               		:data-vv-as="item.name"
									               		:error-messages="errors.collect('fields.percent'+index)">
										           	</v-text-field>

										        </v-flex>

										        <v-flex xs6 sm6 md6 pr-3 pl-2>
										           	<v-text-field 
										           		:disabled="disableBtn"
										           		v-model.number="item.value"
										           		@input="item.percentage = null"
										           		prefix="₹"
										           		:suffix="item.nature ? '(-)' : ''"
										           		label=""
										           		placeholder=" "
										           		type="number"
										           		v-validate="'min_value:0|decimal:2'" 
									               		:data-vv-name="'value'+index" 
									               		:data-vv-as="item.name"
									               		:error-messages="errors.collect('fields.value'+index)">
										           	</v-text-field>

										        </v-flex>
								        	</v-layout>

								        	<v-flex xs12 sm12 md12 form-item v-else>
									           	<v-text-field 
									           		:disabled="disableBtn"
									           		prefix="₹"
									           		v-model.number="item.value"
									           		:label="item.name"
										           	:suffix="item.nature ? '(-)' : ''"
									           		placeholder=" "
									           		type="number"
									           		v-validate="'min_value:0|decimal:2'" 
								               		:data-vv-name="'value'+index" 
								               		:data-vv-as="item.name"
								               		:error-messages="errors.collect('fields.value'+index)">
									           	</v-text-field>

									        </v-flex>

								        </v-layout>
							        </div>

							        <!-- <div white-background v-if="$parent.Form.taxMode && product.taxValue!=null"> -->
							        <div white-background padding-top-ten>

								        <template v-if="$parent.Form.taxMode">

								        	<v-layout row wrap>
								        		<v-flex xs12 sm12 md12 form-item @click="openTaxCategories(product.taxCategoryId, itemIndex)">
								        			<v-text-field  
										               	readonly
										               	:disabled="$parent.Form.transactionData.invoiceType == 0 || disableBtn ? true : false"
										               	v-model="product.taxCategoryName" 
										               	label="Tax Category" 
										               	placeholder=" " 
										               	append-icon="arrow_drop_down">
									               </v-text-field>
								        		</v-flex>
								        	</v-layout>

								        	<v-layout row wrap>

								        		<v-flex xs6 sm6 md6 pr-2 pl-3>
										           	<v-text-field 
										           		suffix="%"
										           		:disabled="true"
										           		v-model="product.taxValue"
										           		label="GST" 
										           		placeholder=" ">
										           	</v-text-field>
										        </v-flex>

										        <v-flex xs6 sm6 md6 pr-3 pl-2>
										           	<v-text-field 
										           		:disabled="true"
										           		v-model="product.taxAmount"
										           		label="" 
										           		prefix="₹"
										           		placeholder=" ">
										           	</v-text-field>
										        </v-flex>   

								        	</v-layout>

								        	<v-layout row wrap v-if="product.isCessApplicable">

								        		<template v-if="product.cessValue != undefined">
													<v-flex xs6 sm6 md6 pr-2 pl-3>
														<v-text-field 
															:disabled="true"
															v-model="product.cessValue"
															label="Cess (On Value)"
															suffix="%" 
															placeholder=" ">
														</v-text-field>
													</v-flex>

													<v-flex xs6 sm6 md6 pr-3 pl-2>
														<v-text-field 
															:disabled="true"
															@input="product.cessValue = null"
															type="number"
															v-model.number="product.cessAmount"
															label="" 
															prefix="₹"
															placeholder=" "
															v-validate="'min_value:0|decimal:2'" 
															data-vv-name="cessAmount" 
															data-vv-as="cess amount" 
															:error-messages="errors.collect('fields.cessAmount')">
														</v-text-field>
													</v-flex>
												</template>

												<template v-if="product.cessValueOnQuantity != undefined">
													<v-flex xs6 sm6 md6 pr-2 pl-3>
														<v-text-field 
															v-model="product.cessValueOnQuantity"
															label="Cess (Per Qty)"
															prefix="₹" 
															placeholder=" ">
														</v-text-field>
													</v-flex>

													<v-flex xs6 sm6 md6 pr-3 pl-2>
														<v-text-field 
															:disabled="true"
															@input="product.cessAmountOnQty = null"
															type="number"
															v-model.number="product.cessAmountOnQty"
															label="" 
															prefix="₹"
															placeholder=" "
															v-validate="'min_value:0|decimal:2'" 
															data-vv-name="cessQtyAmount" 
															data-vv-as="cess amount" 
															:error-messages="errors.collect('fields.cessQtyAmount')">
														</v-text-field>
													</v-flex>
												</template>

								        	</v-layout>

								        </template>

								        <v-layout row wrap>
								        	<v-flex xs12 sm12 md12 form-item v-if="$root.CurrentBusiness.GSTRegistrationStatus==1 && $root.CurrentBusiness.HSNApplicable">
									           	<v-text-field 
									           		:disabled="disableBtn"
									           		v-model="product.hsnCode"
									           		label="HSN" 
									           		placeholder=" "
									           		v-validate="'verify_hsn'" 
								               		data-vv-name="hsn" 
								               		:error-messages="errors.collect('fields.hsn')">
									           	</v-text-field>
									        </v-flex>

											<v-flex xs12 sm12 md12 form-item v-if="$root.TransactionSettings.showPacking && $parent.toolbarTitle != 'Credit Note'">
									           	<v-text-field 
									           		:disabled="disableBtn"
									           		v-model="product.packing"
									           		:label="$root.TransactionSettings.packingLabel ? $root.TransactionSettings.packingLabel : 'Pack Qty'" 
									           		placeholder=" ">
									           	</v-text-field>
									        </v-flex>
								        </v-layout>
							        </div>

									<!-- <div full-width v-for="(dItem, dIndex) in $parent.Form.dynamicItemSection" :key="dIndex"> -->
										<!-- <v-list nopadding white-background v-if="!product.customFields || !product.customFields.length">
											<v-list-tile @click="$parent.fn_bindDynamicItemFields(dItem.sectionId)" v-if="!dItem.hideOption">
												<v-list-tile-content>
													<v-list-tile-title>{{dItem.Text}} s</v-list-tile-title>
												</v-list-tile-content>
												<v-list-tile-action>
													<v-icon>keyboard_arrow_right</v-icon>
												</v-list-tile-action>
											</v-list-tile>
										</v-list> -->

									<v-list white-background full-width nopadding v-if="netTotal">
										<v-list-tile>
											<v-list-tile-content>
												<v-list-tile-title>Item Total</v-list-tile-title>
											</v-list-tile-content>
											<v-list-tile-action>&#8377; {{$root.numberToLocale(netTotal)}}</v-list-tile-action>
										</v-list-tile>
									</v-list>

									<v-layout white-background wrap margin-top-ten pb-3 pt-3>
										<v-flex xs12 sm12 md12 form-item>
											<v-textarea
												:disabled="disableBtn"
												v-validate="'max:255'"
												data-vv-name="notes" 
												:error-messages="errors.collect('fields.notes')"
												v-model="product.description"
												label="Notes"
												placeholder=" "
												rows="2"
												:counter="255">
											</v-textarea>
										</v-flex>
									</v-layout>

							    <!-- </v-expansion-panel-content>
							</v-expansion-panel> -->

        	  			</div>
        	  			
        	  			<!-- <div>

							<v-layout row wrap margin-top-ten padding-top-ten white-background v-if="$parent.Form.productDataModel.productName">
								<v-flex xs6 sm6 md6 pr-2 pl-3 v-if="$parent.Form.productDataModel.groupTypeId == 101 && $root.TransactionSettings.mrpWiseStock">
						           	<v-text-field 
						           		:disabled="$root.TransactionSettings.mrpWiseStock && $root.TransactionSettings.disableNegativeStock"
						           		v-model.number="$parent.Form.productDataModel.mrp"
						           		label="MRP" 
						           		placeholder=" "
						           		type="number"
						           		v-validate="'min_value:0|decimal:2'" 
					               		data-vv-name="mrp" 
					               		:error-messages="errors.collect('fields.mrp')">
						           	</v-text-field>
						        </v-flex>

						        <v-flex :class="[$parent.Form.productDataModel.groupTypeId == 102 || !$root.TransactionSettings.mrpWiseStock ? 'xs12 sm12 md12 pr-3 pl-3' : 'xs6 sm6 md6 pr-3 pl-2']">
						           	<v-text-field 
						           		v-model.number="$parent.Form.productDataModel.rate"
						           		:label="$parent.Form.productDataModel.groupTypeId == 102 ? 'Amount' : 'Rate'"
						           		placeholder=" "
						           		type="number"
						           		v-validate="'min_value:0|decimal:2'" 
					               		data-vv-name="rate" 
					               		:error-messages="errors.collect('fields.rate')">
						           	</v-text-field>	
						        </v-flex>

						        <v-layout row wrap v-for="(item, vIndex) in $parent.Form.productDataModel.productVariants" :key="vIndex">
						        	 <v-flex xs12 sm12 md12 form-item>
							           	<v-text-field 
							           		v-model.number="item.qty"
							           		:hint="item.billQty != undefined ? 'Bill Qty: ' + item.billQty : ''"
							           		persistent-hint
							           		@input="fn_checkInput(item)"
							           		:label="fn_getLabel(item)" 
							           		placeholder=" "
							           		type="number"
							           		v-validate="'numeric|max:8'" 
						               		:data-vv-name="item.unitName+vIndex" 
						               		data-vv-as="quantity"
						               		:error-messages="errors.collect('fields.'+item.unitName+vIndex)">
							           	</v-text-field>
							        </v-flex>
						        </v-layout>

						        <v-flex xs12 sm12 md12 form-item v-if="$parent.Form.productDataModel.groupTypeId == 102">
						           	<v-textarea 
					               		rows="2" 
					               		v-model="$parent.Form.productDataModel.description"
					               		placeholder=" " 
					               		label="Description"
					               		:counter="120"
					               		v-validate="'max:120'"
					               		data-vv-name="description" 
					               		:error-messages="errors.collect('fields.description')">
				               		</v-textarea>
						        </v-flex>

							</v-layout>

					        <div white-background margin-top-ten v-if="$parent.Form.productDataModel.addOnsItems.length">
					        	<v-subheader>Discounts/Taxes/Other Charges</v-subheader>
					        	<v-divider></v-divider>
						        <v-layout row wrap padding-top-ten v-for="(item, index) in $parent.Form.productDataModel.addOnsItems" :key="index" v-if="!item.isGst">

						        	<v-layout row wrap v-if="item.mode==0">
						        		<v-flex xs6 sm6 md6 form-item pr-2 pl-3>
								           	<v-text-field 
								           		v-model.number="item.percentage"
								           		@input="fn_checkPercentage(item)"
								           		:label="item.name+' (%)'"
								           		placeholder=" "
								           		type="number"
								           		v-validate="'min_value:0|decimal:2'" 
							               		:data-vv-name="'percent'+index" 
							               		:data-vv-as="item.name"
							               		:error-messages="errors.collect('fields.percent'+index)">
								           	</v-text-field>

								        </v-flex>

								        <v-flex xs6 sm6 md6 form-item pr-3 pl-2>
								           	<v-text-field 
								           		v-model.number="item.value"
								           		@input="item.percentage = null"
								           		prefix="₹"
								           		:suffix="item.nature ? '(-)' : '(+)'"
								           		label=""
								           		placeholder=" "
								           		type="number"
								           		v-validate="'min_value:0|decimal:2'" 
							               		:data-vv-name="'value'+index" 
							               		:data-vv-as="item.name"
							               		:error-messages="errors.collect('fields.value'+index)">
								           	</v-text-field>

								        </v-flex>
						        	</v-layout>

						        	<v-flex xs12 sm12 md12 form-item v-else>
							           	<v-text-field 
							           		v-model.number="item.value"
							           		:label="item.name+' (₹)'"
								           	:suffix="item.nature ? '(-)' : '(+)'"
							           		placeholder=" "
							           		type="number"
							           		v-validate="'min_value:0|decimal:2'" 
						               		:data-vv-name="'value'+index" 
						               		:data-vv-as="item.name"
						               		:error-messages="errors.collect('fields.value'+index)">
							           	</v-text-field>

							        </v-flex>

						        </v-layout>
					        </div>

					        <v-layout row wrap margin-top-ten padding-top-ten white-background v-if="$parent.Form.taxMode && $parent.Form.productDataModel.taxValue!=null">

					        	<v-layout row wrap>
					        		<v-flex xs12 sm12 md12 form-item @click="openTaxCategories">
					        			<v-text-field  
							               	readonly
							               	:disabled="$parent.Form.transactionData.invoiceType == 0 ? true : false"
							               	v-model="$parent.Form.productDataModel.taxCategoryName" 
							               	label="Tax Category" 
							               	placeholder=" " 
							               	append-icon="arrow_drop_down">
						               </v-text-field>
					        		</v-flex>
					        	</v-layout>

					        	<v-layout row wrap>

					        		<v-flex xs6 sm6 md6 pr-2 pl-3>
							           	<v-text-field 
							           		:disabled="true"
							           		v-model="$parent.Form.productDataModel.taxValue"
							           		label="Tax(%)" 
							           		placeholder=" ">
							           	</v-text-field>
							        </v-flex>

							        <v-flex xs6 sm6 md6 pr-3 pl-2>
							           	<v-text-field 
							           		:disabled="true"
							           		v-model="$parent.Form.productDataModel.taxAmount"
							           		label="" 
							           		prefix="₹"
							           		suffix="(+)"
							           		placeholder=" ">
							           	</v-text-field>
							        </v-flex>   

					        	</v-layout>

					        	<v-layout row wrap v-if="$parent.Form.productDataModel.isCessApplicable">

					        		<v-flex xs6 sm6 md6 pr-2 pl-3>
							           	<v-text-field 
							           		:disabled="true"
							           		v-model="$parent.Form.productDataModel.cessValue"
							           		label="Cess(%)" 
							           		placeholder=" ">
							           	</v-text-field>
							        </v-flex>

							        <v-flex xs6 sm6 md6 pr-3 pl-2>
							           	<v-text-field 
							           		@input="$parent.Form.productDataModel.cessValue = null"
							           		type="number"
							           		v-model.number="$parent.Form.productDataModel.cessAmount"
							           		label="" 
							           		prefix="₹"
							           		suffix="(+)"
							           		placeholder=" "
							           		v-validate="'min_value:0|decimal:2'" 
						               		data-vv-name="cessAmount" 
						               		data-vv-as="cess amount" 
						               		:error-messages="errors.collect('fields.cessAmount')">
							           	</v-text-field>
							        </v-flex>   

					        	</v-layout>

						        <v-flex xs12 sm12 md12 form-item>
						           	<v-text-field 
						           		v-model="$parent.Form.productDataModel.hsnCode"
						           		label="HSN" 
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>
					        </v-layout>

        	  			</div> -->
						
        	  		</v-form>
        	  		
        	  	</v-card-text>
        	  	<!-- <v-divider v-show="false"></v-divider>
		        <v-card-actions :class="{'error--text':netTotal<0}" v-show="false">
		          Amount<v-spacer></v-spacer>&#8377; {{netTotal ? $root.numberToLocale(netTotal) : netTotal}}
		        </v-card-actions> -->

		        <div white-background full-width nopadding style="position:fixed;bottom:0;">
					<template v-if="$parent.Form.productData.items.length && $parent.Form.productData.items[0].batches && $parent.Form.productData.items[0].batches.length">
						<v-layout row wrap>
							<v-flex xs6 sm6 md6 pl-3 pt-1 pb-1 white-background>
								Total Qty:
							</v-flex>
							<v-flex xs6 sm6 md6 pr-3 pt-1 pb-1 right-align white-background>
								{{ $parent.Form.productData.items[0].productVariants[0].qty }} {{ $parent.Form.productData.items[0].productVariants[0].selectedUnit ? $parent.Form.productData.items[0].productVariants[0].selectedUnit.itemName : $parent.Form.productData.items[0].productVariants[0].unitName }}
							</v-flex>
						</v-layout>
					</template>
					<v-layout row wrap style="background:#ddd;">
						<v-flex xs6 sm6 md6>
							<!-- <v-btn style="height:48px !important" nomargin block no-round-borders noshadow :disabled="disableBtn || $parent.Form.productDataModel.fromScanner" @click="fn_checkValidations(true)">Done &amp; New</v-btn> -->
							<v-btn style="height:48px !important" nomargin block no-round-borders noshadow :disabled="disableBtn || $parent.Form.productDataModel.fromScanner" @click="fn_checkFields(true)">Done &amp; New</v-btn>
						</v-flex>
						<v-flex xs6 sm6 md6>
							<!-- <v-btn style="height:48px !important" color="primary" nomargin block no-round-borders noshadow :disabled="disableBtn" @click="fn_checkValidations(false)">Done</v-btn> -->
							<v-btn style="height:48px !important" color="primary" nomargin block no-round-borders noshadow :disabled="disableBtn" @click="fn_checkFields(false)">Done</v-btn>
						</v-flex>
					</v-layout>
				</div>
		        
	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
// const menuItem = require('../../../../../config.js').configs.menuItem;
const transactionTypes = require('../../../../../config.js').configs.transactionTypes;
import componentDynamicFields from '../../../../dialogs/component_dynamic_fields'

export default{
	props:['openProducts', 'openTaxCategories', 'saveItem'],
	components:{
		'component-dynamic-fields':componentDynamicFields
	},
	data(){	
		return{
			dialog_product: false,
			summaryArray:[],
			disableBtn:false,
			hasOnlySeries:true,
			hasSeries:false,
			seriesFields:[],
			dialogJustOpen:true
			// tempRate:null
		}
	},
	methods:{
		openDialogWeb: function () {
			if(!this.dialog_product){
				this.$validator.reset();
				this.summaryArray = [];
				this.dialog_product = true;
			}

			this.seriesFields = [];

			if(this.$root.TransactionSettings.enableBatch && this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
				for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
					let field = this.$root.TransactionSettings.batchFields[i]
					if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
						this.hasSeries = true;
						this.seriesFields.push(field);
					}

					if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
						this.hasOnlySeries = false;
					}
				}

				if(!this.$parent.Form.selectedBatchType){
					this.$parent.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
				}
			}
			
			

			// setTimeout(() => {
			// 	if(localStorage.getItem('batch_data') && this.$parent.Form.productData.items && this.$parent.Form.productData.items.length){
			// 		if(!this.$parent.Form.productData.items[0].batches || !this.$parent.Form.productData.items[0].batches.length){
			// 			this.$parent.Form.productData.items[0].batches = [];
			// 		}
			// 		let bArray = JSON.parse(localStorage.getItem('batch_data'));
			// 		for(let i=0; i<bArray.length; i++){
			// 			bArray[i].productQty = null;
			// 			this.$parent.Form.batches.push(JSON.parse(JSON.stringify(bArray[i])));
			// 			this.$parent.Form.productData.items[0].batches.push(JSON.parse(JSON.stringify(bArray[i])));
			// 			this.$forceUpdate();
			// 			this.$parent.fn_saveDraft(this.$parent.Form.partyName);
			// 		}

			// 		localStorage.removeItem('batch_data');
			// 	}
			// }, 1000);
			this.dialogJustOpen = true;
			setTimeout(() => {
				this.dialogJustOpen = false;
			}, 500);
		},
		closeDialogWeb: function () {
			this.dialog_product = false;
		},
		fn_getBillQty(item){
			if(item.billQty != undefined){
				let unitName = item.selectedUnit ? item.selectedUnit.itemName : item.unitName;
				return 'Bill Qty: ' + item.billQty + ' ' + unitName;
			}
			else{
				return '';
			}
			// if(variant.primaryUnitId == variant.unitId && variant.selectedUnit.itemId != variant.primaryUnitId){
			// 	return this.roundUpto2Decimals((variant.billQty * variant.secondaryUnitPackQuantity) / variant.packQuantity);
			// }
			// else if(variant.secondaryUnitId == variant.unitId && variant.selectedUnit.itemId != variant.secondaryUnitId){
			// 	return this.roundUpto2Decimals(variant.billQty / variant.secondaryUnitPackQuantity);
			// }
			// else{
			// 	return variant.billQty;
			// }
		},
		fn_checkInput: function (variant, isReturn) {
			let isQtyValid = true;
			if(variant.secondaryUnitId){
				if(variant.primaryUnitId == variant.unitId && variant.selectedUnit.itemId != variant.primaryUnitId){
					if(variant.billQty != undefined && variant.qty > ((variant.billQty * variant.secondaryUnitPackQuantity) / variant.packQuantity)){
						this.showToast("Quantity should be less then or equal to bill quantity");
						isQtyValid = false;
					}
				}
				else if(variant.secondaryUnitId == variant.unitId && variant.selectedUnit.itemId != variant.secondaryUnitId){
					if(variant.billQty != undefined && variant.qty > (variant.billQty / variant.secondaryUnitPackQuantity)){
						this.showToast("Quantity should be less then or equal to bill quantity");
						isQtyValid = false;
					}
				}
				else{
					if(variant.billQty != undefined && variant.qty > variant.billQty){
						this.showToast("Quantity should be less then or equal to bill quantity");
						isQtyValid = false;
					}
				}
			}
			else{
				if(variant.billQty != undefined && variant.qty > variant.billQty){
					this.showToast("Quantity should be less then or equal to bill quantity");
					isQtyValid = false;
				}
			}

			if(isReturn){
				return isQtyValid;
			}
			// if(variant.secondaryUnitId){
			// 	if(variant.unitId == variant.primaryUnitId && variant.selectedUnit.itemId == variant.secondaryUnitId){
			// 		if(variant.billQty != undefined && variant.qty > ((variant.billQty * variant.packQuantity) / variant.secondaryUnitPackQuantity)){
			// 			this.showToast("Quantity should be less then or equal to bill quantity");
			// 		}
			// 	}
			// 	else{
			// 		if(variant.billQty != undefined && variant.qty > variant.billQty){
			// 			this.showToast("Quantity should be less then or equal to bill quantity");
			// 		}
			// 	}
			// }
			// else{
			// 	if(variant.billQty != undefined && variant.qty > variant.billQty){
			// 		// this.$parent.snackbar_msg = 'Return quantity should be less then or equal to bill quantity';
			// 		// this.$parent.snackbar = true;
			// 		this.showToast("Quantity should be less then or equal to bill quantity");
			// 	}
			// }
		},
		fn_openProducts: function () {
			// this.openProducts('android', 'Products', 'ref_dialogProduct_productName', this.$parent.Form.productDataModel.productId, this.$parent.Form.productDataModel.productName);
			this.openProducts('android', 'Products', 'ref_dialogProduct_productName', this.$parent.Form.productData.productId, this.$parent.Form.productData.productName);
		},
		fn_updateProduct: function (selectedValueId, selectedValueName, isRemoved) {
			if(!isRemoved){
				// this.$parent.Form.productDataModel.productId = selectedValueId;
	   //      	this.$parent.Form.productDataModel.productName = selectedValueName;

	   			if(this.$parent.Form.productData.productId!=selectedValueId){
	   				let self = this;
	   				this.disableBtn = true;
	   				this.fn_getProductData(false, selectedValueId, null, function(){
	   					self.$parent.Form.productData.items = [];
						self.$parent.Form.productData.items.push(JSON.parse(JSON.stringify(self.$parent.Form.productDataModel)));

						if(self.$parent.Form.productData && self.$parent.Form.productData.items && self.$parent.Form.productData.items.length && !self.$parent.Form.productData.items[0].productVariants[0].secondaryUnitId){
							self.$parent.Form.productData.items[0].productVariants[0].selectedUnit = null;
						}

						// binding custom item fields if any
						if(self.$parent.Form.dynamicItemSection && self.$parent.Form.dynamicItemSection.length){
							self.$parent.fn_bindDynamicItemFields(self.$parent.Form.dynamicItemSection[0].sectionId);
						}
			   			// if(self.$root.TransactionSettings.mrpWiseStock){
			        	// 	self.fn_getItemGroups(selectedValueId);
			        	// }
			        	// else{
			        	// 	self.$parent.Form.productData.items.push(JSON.parse(JSON.stringify(self.$parent.Form.productDataModel)));
			        	// }

			        	setTimeout(function(){
			        		self.disableBtn = false;
			        	},100);
	   				});

	   				
	   			}
	   			
	   			this.$parent.Form.productData.productId = selectedValueId;
	        	this.$parent.Form.productData.productName = selectedValueName;
	        	this.$forceUpdate();
	        	this.errors.remove('fields.item');
	        	// this.fn_getProductData(false, selectedValueId);
	        	
	        	// if(this.$root.TransactionSettings.mrpWiseStock){
	        	// 	this.fn_getItemGroups(selectedValueId);
	        	// }
	        	// else{
	        	// 	this.$parent.Form.productData.items.push(JSON.parse(JSON.stringify(this.$parent.Form.productDataModel)));
	        	// }
			}
			else{
				this.$parent.Form.productData.productId = null;
	        	this.$parent.Form.productData.productName = null;
			}
		},
		fn_getItemGroups: function (itemId) {

			let filterObject = {};
			filterObject.endDate = new Date();

			var self = this;
			this.getFilterData('ItemGroupsByMRP', itemId, filterObject, 
				{
					onSuccess: function(response){
						console.log(response);
						let data = JSON.parse(response);
						if(data.transactionProductGroups){
							self.$parent.itemGroups = data.transactionProductGroups;	
						}
						else{
							self.$parent.itemGroups = [];
						}

						// if(self.$parent.Form.transactionData.transactionListId == transactionTypes.salesInvoice.id){

							if(self.$parent.itemGroups.length<=1){
								self.$parent.itemGroups.length == 1 ? self.$parent.Form.productDataModel.mrp = self.$parent.itemGroups[0].mrp : '';
								self.$parent.Form.productData.items.push(JSON.parse(JSON.stringify(self.$parent.Form.productDataModel)));
							}
							else if(self.$parent.itemGroups.length>1){
								self.$parent.fn_openItemGroups();
							}
								
						// }
						
						
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		// fn_getItemGroups: function (itemId) {
		// 	var self = this;
		// 	this.getData('ItemGroupsByMRP', itemId, 
		// 		{
		// 			onSuccess: function(response){
		// 				console.log(response);
		// 				let data = JSON.parse(response);
		// 				if(data.transactionProductGroups){
		// 					self.$parent.itemGroups = data.transactionProductGroups;	
		// 				}
		// 				else{
		// 					self.$parent.itemGroups = [];
		// 				}

		// 				if(self.$parent.Form.transactionData.transactionListId == transactionTypes.salesInvoice.id){

		// 					if(self.$parent.itemGroups.length==1){
		// 						self.$parent.Form.productDataModel.mrp = self.$parent.itemGroups[0].mrp;
		// 					}
		// 					else if(self.$parent.itemGroups.length>1){
		// 						self.$parent.fn_openItemGroups();
		// 					}
								
		// 				}
						
						
		// 	        }, 
		// 	        onError: function(error){
		// 	          console.log(error);
		// 	        }
		// 		}
	 //        );
		// },
		fn_getProductData: function (refreshUnits, itemId, baseTransactionListId, callback) {
			let self = this;
			this.getData('Product', itemId, 
				{
					onSuccess: function(response){
			          	console.log(response);
			          	let productData = JSON.parse(response);

			          	if(productData.groupTypeId==101){
							if(self.$parent.Form.godownId){
								self.fn_getSummaryGodownWise(productData.productId, productData);
							}
							else{
								self.fn_getSummary(productData.productId, productData);
							}
				       	}

				        if(refreshUnits){
				          	// self.fn_refreshUnits(productData.productVariants, baseTransactionListId);
				          	for(let i=0;i<self.$parent.Form.productData.items.length; i++){
				          		(function(index){
				          			let product = self.$parent.Form.productData.items[index];
				          			if(productData.productVariants.length != product.productVariants.length){
				          				self.fn_refreshUnits(productData.productVariants, baseTransactionListId, product.productVariants);
				          			}
				          		}(i))
				          	}

							if(productData.productVariants[0].secondaryUnitId){
								// self.$parent.Form.productData.items[0].productVariants[0].selectedUnit = {};

								// let selectedUnitId = null;
								// let selectedUnitName = null;

								// if(self.$parent.Form.productData.items[0].productVariants[0].selectedUnit && self.$parent.Form.productData.items[0].productVariants[0].selectedUnit.itemId){
								// 	selectedUnitId = self.$parent.Form.productData.items[0].productVariants[0].selectedUnit.itemId;
								// 	selectedUnitName = self.$parent.Form.productData.items[0].productVariants[0].selectedUnit.itemName;
								// }
								// else{
								// 	if(productData.productVariants[0].unitId == self.$parent.Form.productData.items[0].productVariants[0].unitId){
								// 		selectedUnitId = productData.productVariants[0].unitId;
								// 		selectedUnitName = productData.productVariants[0].unitName;
								// 	}
								// 	else{
								// 		selectedUnitId = productData.productVariants[0].secondaryUnitId;
								// 		selectedUnitName = productData.productVariants[0].secondaryUnitName;
								// 	}
								// }
								
								// self.$parent.Form.productData.items[0].productVariants[0].selectedUnit.itemId = selectedUnitId;
								// self.$parent.Form.productData.items[0].productVariants[0].selectedUnit.itemName = selectedUnitName;

								// self.$parent.Form.productData.items[0].productVariants[0].unitId = productData.productVariants[0].unitId;
								// self.$parent.Form.productData.items[0].productVariants[0].unitName = productData.productVariants[0].unitName;

								// self.$parent.Form.productData.items[0].productVariants[0].secondaryUnitId = productData.productVariants[0].secondaryUnitId;
								// self.$parent.Form.productData.items[0].productVariants[0].secondaryUnitName = productData.productVariants[0].secondaryUnitName;

								// self.$parent.Form.productData.items[0].productVariants[0].secondaryUnitPackQuantity = productData.productVariants[0].secondaryUnitPackQuantity;

								// if(!self.$parent.Form.productData.items[0].productVariants[0].primaryUnitId){
								// 	self.$parent.Form.productData.items[0].productVariants[0].primaryUnitId = productData.productVariants[0].unitId;
								// 	self.$parent.Form.productData.items[0].productVariants[0].primaryUnitName = productData.productVariants[0].unitName;
								// 	self.$parent.Form.productData.items[0].productVariants[0].packQuantity = productData.productVariants[0].packQuantity;
								// }
								// else{
								// 	if(self.$parent.Form.productData.items[0].productVariants[0].primaryUnitId && self.$parent.Form.productData.items[0].productVariants[0].primaryUnitName){
								// 		self.$parent.Form.productData.items[0].productVariants[0].unitId = self.$parent.Form.productData.items[0].productVariants[0].primaryUnitId;
								// 		self.$parent.Form.productData.items[0].productVariants[0].unitName = self.$parent.Form.productData.items[0].productVariants[0].primaryUnitName;
								// 		self.$parent.Form.productData.items[0].productVariants[0].packQuantity = self.$parent.Form.productData.items[0].productVariants[0].packQuantity;
								// 	}
								// }

								if(!self.$parent.Form.productData.items[0].productVariants[0].secondaryUnitId){
									self.$parent.Form.productData.items[0].productVariants[0].secondaryUnitId = productData.productVariants[0].secondaryUnitId;
									self.$parent.Form.productData.items[0].productVariants[0].secondaryUnitName = productData.productVariants[0].secondaryUnitName;
									self.$parent.Form.productData.items[0].productVariants[0].secondaryUnitPackQuantity = productData.productVariants[0].secondaryUnitPackQuantity;

									if(!self.$parent.Form.productData.items[0].productVariants[0].packQuantity || (self.$parent.Form.productData.items[0].productVariants[0].packQuantity != productData.productVariants[0].packQuantity)){
										self.$parent.Form.productData.items[0].productVariants[0].packQuantity = productData.productVariants[0].packQuantity;
									}
								}
							}
				        }
				        else{
				          	self.fn_bindData(productData, callback);
				        }

						self.$parent.Form.productDataModel.purchaseRate = productData.purchaseRate;
			        }, 
			        onError: function(error){
			          	console.log(error);
			        }
				}
	        );
		},
		fn_refreshUnits: function (variants, baseTransactionListId, productVariants) {
			// let productVariants = this.$parent.Form.productDataModel.productVariants;
      		// if(variants.length != productVariants.length){

				for(var j in variants){
				   	var shared = false;

				   	for (var k in productVariants){
				   		if (productVariants[k].productVariantId == variants[j].productVariantId) {
				           shared = true;
				           break;
				       }
				   	}
				       
				   	if(!shared){
				   		let variantObj = {};

			          	variantObj.unitName = variants[j].unitName;
			          	variantObj.unitId = variants[j].unitId;
			          	variantObj.primaryUnitId = variants[j].variantBaseUnitId;
			          	variantObj.packQuantity = variants[j].packQuantity;
			          	variantObj.productId = variants[j].productId;
			          	variantObj.productVariantId = variants[j].productVariantId;

			          	variantObj.qty = null;

			          	//adding bill qty 0 while ading variant in case of edit
			          	if(this.$parent.Form.transactionData.transactionListId == transactionTypes.salesReturn.id && baseTransactionListId == transactionTypes.salesInvoice.id){
			          		variantObj.billQty = 0;
			          	}

			          	productVariants.splice(j, 0, variantObj);
				   	} 
				// }

			}
		},
		fn_bindData: function (productData, callback) {
			this.$parent.Form.partyWiseItemRate = null;
			this.$parent.Form.productDataModel.groupTypeId = productData.groupTypeId;
			this.$parent.Form.productDataModel.productVariants = JSON.parse(JSON.stringify(productData.productVariants));

			self = this;
			this.$parent.Form.productDataModel.productVariants.forEach( function(item) {
				item.primaryUnitId = item.variantBaseUnitId;
				item.primaryUnitName = item.unitName;
				// productData.groupTypeId == 102 ? self.$set(item, 'qty', 1) : '';
				self.$set(item, 'qty', 1);

				//setting pack quantity 1 in case of null or base variant
				!item.packQuantity ? item.packQuantity = 1 : '';

				if(item.secondaryUnitId && !item.selectedUnit){
					item.selectedUnit = {};
					item.selectedUnit.itemId = item.unitId;
					item.selectedUnit.itemName = item.unitName;
				}
			});

			this.$parent.Form.productDataModel.mrp = productData.mrp;
			this.$parent.Form.productDataModel.defaultSellingPrice = productData.sellingPrice;
			this.$parent.Form.productDataModel.defaultWholeSalePrice = productData.wholeSalePrice;	

			if(this.$parent.Form.transactionTypeData.tradingType == 1){
				this.$parent.Form.productDataModel.rate = productData.wholeSalePrice;
				this.$parent.Form.productDataModel.defaultRate = productData.wholeSalePrice;
			}
			else{
				this.$parent.Form.productDataModel.rate = productData.sellingPrice;
				this.$parent.Form.productDataModel.defaultRate = productData.sellingPrice;
			}

			if(this.$root.TransactionSettings.mrpWiseStock && this.$root.TransactionSettings.mrpAsSalePrice && productData.mrp){
				this.$parent.Form.productDataModel.rate = productData.mrp;
			}

			if(this.$parent.fn_isNewTaxForm()){
				this.$parent.Form.productDataModel.taxValue = productData.newTaxValue;
				this.$parent.Form.productDataModel.cessValue = productData.newCessValue;
				this.$parent.Form.productDataModel.cessValueOnQuantity = productData.newCessValueOnQuantity ? productData.newCessValueOnQuantity : null;
				this.$parent.Form.productDataModel.taxCategoryId = productData.newTaxCategoryId;
				this.$parent.Form.productDataModel.taxCategoryName = productData.newTaxCategoryName;
				//saving default tax value for draft
				this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.newTaxCategoryId;
				this.$parent.Form.productDataModel.defaultTaxValue = productData.newTaxValue;
				this.$parent.Form.productDataModel.defaultCessValue = productData.newCessValue;
				// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;

				this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable || productData.newCessValue || productData.newCessValueOnQuantity ? true : false;
				this.$parent.fn_checkTaxCategory();
			}
			else{
				this.$parent.Form.productDataModel.taxValue = productData.taxValue;
				this.$parent.Form.productDataModel.cessValue = productData.cessValue;
				this.$parent.Form.productDataModel.cessValueOnQuantity = productData.cessValueOnQuantity ? productData.cessValueOnQuantity : null;
				this.$parent.Form.productDataModel.taxCategoryId = productData.taxCategoryId;
				this.$parent.Form.productDataModel.taxCategoryName = productData.taxCategoryName;
				this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.taxCategoryId;
				this.$parent.Form.productDataModel.defaultTaxValue = productData.taxValue;
				this.$parent.Form.productDataModel.defaultCessValue = productData.cessValue;
				// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;

				this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable || productData.cessValue || productData.cessValueOnQuantity ? true : false;
			}
			
			// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;

			this.$parent.Form.productDataModel.hsnCode = productData.hsnCode;

			this.$parent.Form.productDataModel.packing = productData.packing;

			// //saving default tax value for draft
			// this.$parent.Form.productDataModel.defaultTaxValue = productData.taxValue;
			// this.$parent.Form.productDataModel.defaultCessValue = productData.cessValue;

			//charges in case of service item
			if(productData.groupTypeId==102){
				this.$parent.Form.productDataModel.rate = productData.charges;	
			}

			if(productData.groupTypeId==101){
				this.fn_getBatches(productData.productId);
			}

			if(productData.accountId){
				this.$parent.Form.productDataModel.serviceAccountItemId = productData.accountId;
			}

			if(this.$root.TransactionSettings.partyWiseRate){
				this.fn_getPartyWiseRate(productData);
			}

			callback ? callback() : '';
		},
		fn_getBatches: function(productId, addedBatches){
            let self = this;
            this.getData('GetProductBatchByProductId', productId, 
                {
                    onSuccess: function(response){
                        console.log(response);
						self.$set(self.$parent.Form, 'batches', JSON.parse(response));

						if(addedBatches && addedBatches.length){
							for(let i=0; i<addedBatches.length; i++){
								let bIndex = self.$parent.Form.batches.findIndex(bItem=>{return bItem.batchId == addedBatches[i].batchId});
								if(bIndex == -1){
									self.$parent.Form.batches.push(addedBatches[i]);
								}
							}
						}
						// if(self.$parent.Form.productData.batches && self.$parent.Form.productData.batches.length){
						// 	self.$parent.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
						// }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },
		fn_openDialogSelectBatch: function(){
			// if(this.$parent.Form.productData.items && this.$parent.Form.productData.items.length && this.$parent.Form.productData.items[0].batches && this.$parent.Form.productData.items[0].batches.length){
			if(this.$parent.Form.productData.items && this.$parent.Form.productData.items.length){
				for(let i=0; i<this.$parent.Form.batches.length; i++){
					this.$parent.Form.batches[i].productQty = null;
					this.$set(this.$parent.Form.batches[i], 'selected', false);
					if(this.$parent.Form.productData.items[0].batches && this.$parent.Form.productData.items[0].batches.length){
						for(let j=0; j<this.$parent.Form.productData.items[0].batches.length; j++){
							if(this.$parent.Form.productData.items[0].batches[j].batchId == this.$parent.Form.batches[i].batchId){
								if(this.$parent.Form.productData.items[0].batches[j].productQty){
									this.$parent.Form.batches[i].selected = true;
									this.$parent.Form.batches[i].productQty = this.$parent.Form.productData.items[0].batches[j].productQty;
									this.$parent.Form.productData.items[0].batches[j].billQty ? this.$parent.Form.batches[i].billQty = this.$parent.Form.productData.items[0].batches[j].billQty : '';

									this.$parent.Form.productData.items[0].batches[j].isAdded != undefined ? this.$parent.Form.batches[i].isAdded = this.$parent.Form.productData.items[0].batches[j].isAdded : '';
									this.$parent.Form.productData.items[0].batches[j].qty != undefined ? this.$parent.Form.batches[i].qty = this.$parent.Form.productData.items[0].batches[j].qty : '';
									this.$parent.Form.productData.items[0].batches[j].refTId != undefined ? this.$parent.Form.batches[i].refTId = this.$parent.Form.productData.items[0].batches[j].refTId : '';
									this.$parent.Form.productData.items[0].batches[j].refTpBatchId != undefined ? this.$parent.Form.batches[i].refTpBatchId = this.$parent.Form.productData.items[0].batches[j].refTpBatchId : '';
									// this.$parent.Form.productData.items[0].batches[j].transactionProductBatchId != undefined ? this.$parent.Form.batches[i].transactionProductBatchId = this.$parent.Form.productData.items[0].batches[j].transactionProductBatchId : '';
									if(this.$parent.Form.productData.items[0].batches[j].refTransactionProductBatchId){
										this.$parent.Form.batches[i].transactionProductBatchId = this.$parent.Form.productData.items[0].batches[j].refTransactionProductBatchId;
									}
									else{
										this.$parent.Form.productData.items[0].batches[j].transactionProductBatchId != undefined ? this.$parent.Form.batches[i].transactionProductBatchId = this.$parent.Form.productData.items[0].batches[j].transactionProductBatchId : '';
									}

									this.$parent.Form.productData.items[0].batches[j].transactionProductId != undefined ? this.$parent.Form.batches[i].transactionProductId = this.$parent.Form.productData.items[0].batches[j].transactionProductId : '';
								}
								// else{
								// 	this.$parent.Form.batches[i].productQty = null;   
								// }
							}
						}
					}					
				}
			}

			// if(!this.hasOnlySeries && !this.$parent.Form.selectedBatchType){
			// 	this.$parent.Form.selectedBatchType = 1;
			// }
			this.$parent.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
		},
		fn_showHideBatches: function(field){
			if(this.$parent.Form.selectedBatchType == 2 && !field.batchNumber && !field.batchMRP && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4){
				return true;
			}
			else if(this.$parent.Form.selectedBatchType == 1 && !field.field1 && !field.field2 && !field.field3){
				return true;
			}
			else{
				return false;
			}
		},
		// fn_changeSeriesType: function(){
		// 	// this.$parent.Form.productData.items[0].batches = [];
		// 	if(this.$parent.Form.selectedBatchType == 2){
        //         this.$parent.Form.batches = this.$parent.Form.batches.filter(field=>{
        //             return !field.batchNumber && !field.batchMRP && !field.batchSize && !field.mfgDate && !field.expDate && !field.opening && !field.field4
        //         })
        //     }
        //     else{
        //         this.$parent.Form.batches = this.$parent.Form.batches.filter(field=>{
        //             return !field.field1 && !field.field2 && !field.field3
        //         })
        //     }
		// },
		fn_newBatch: function(){
            this.$parent.backButtonPress = false;
			this.$router.push({path:"/product/batches", query:{pid:this.$parent.Form.productData.productId, dialog:1, new:1}});	
            // if(this.$parent.Form.batches && this.$parent.Form.batches.length){
            //     this.$router.push({path:"/product/batches", query:{pid:this.$parent.Form.batches[0].productId, dialog:1, new:1}});	
            // }
            // else{
            //     this.$router.push({path:"/product/batches", dialog:1});
            // }
        },
		fn_changeProductQty: function(item){
			if(this.$parent.Form.productData.items[0].batches && this.$parent.Form.productData.items[0].batches.length && this.$parent.Form.productData.items[0].batches.length == 1){
				this.$parent.Form.productData.items[0].batches[0].productQty = item.qty;
			}
			this.$root.fn_boundDecimalLength(item, this.fn_checkInput, 'qty');
		},
		fn_changeBatchQty: function(batch){
			if(this.$parent.Form.productData.items[0].batches && this.$parent.Form.productData.items[0].batches.length){
				let totalVal = 0;
				for(let i=0; i<this.$parent.Form.productData.items[0].batches.length; i++){
					totalVal += this.$parent.Form.productData.items[0].batches[i].productQty;
				}
				// this.$parent.Form.productData.items[0].productVariants[0].qty = Number(totalVal);
				this.$set(this.$parent.Form.productData.items[0].productVariants[0], 'qty', Number(totalVal));
			}

			if(batch.billQty != undefined && batch.productQty > batch.billQty){
				this.showToast("Batch quantity should be less then or equal to bill quantity");
			}
		},
		// fn_batchQty: function(val){
		// 	if(!this.$parent.Form.productData.items[0].batches || !this.$parent.Form.productData.items[0].batches.length){
		// 		this.$parent.Form.productData.items[0].productVariants[0].qty = val;
		// 	}
		// },
		fn_getLabel: function (item) {
			return item.unitName;
			// if(!item.packQuantity){
			// 	return item.unitName;
			// }
			// else{
			// 	return item.unitName+'('+item.packQuantity+')';
			// }
		},
		fn_getSummary: function (itemId, productData) {
			var self = this;
			this.getData('ProductSummary', itemId, 
				{
					onSuccess: function(response){
						console.log(response);
						self.summaryArray = JSON.parse(response);
						if(self.$root.TransactionSettings.lowStockAlert && ((self.summaryArray && self.summaryArray.length && self.summaryArray[0].qty <= productData.productVariants[0].lowStockQuantity) || self.summaryArray[0].qty <= 0)){
							self.$parent.confirmationHeader = "Low Stock Alert";
							self.$parent.confirmationMessage = "Stock quantity is low. Would you like to continue";
							self.$parent.fn_openDialogWeb('web', 'confirmationDialog', 'ref_dialogConfirmation');
							self.$parent.confirmationAction = self.$parent.fn_closeDialog;
						}
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		fn_getSummaryGodownWise: function (itemId, productData) {
			var self = this;
			let filterObj = {};
			filterObj.godownId = this.$parent.Form.godownId;
			filterObj.productId = itemId;
			this.getFilterData('ProductSummary', null, filterObj, 
				{
					onSuccess: function(response){
						console.log(response);
						self.summaryArray = JSON.parse(response);
						if(self.$root.TransactionSettings.lowStockAlert && ((self.summaryArray && self.summaryArray.length && self.summaryArray[0].qty <= productData.productVariants[0].lowStockQuantity) || self.summaryArray[0].qty <= 0)){
							self.$parent.confirmationHeader = "Low Stock Alert";
							self.$parent.confirmationMessage = "Stock quantity is low. Would you like to continue";
							self.$parent.fn_openDialogWeb('web', 'confirmationDialog', 'ref_dialogConfirmation');
							self.$parent.confirmationAction = self.$parent.fn_closeDialog;
						}
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		fn_getAddOnsLabel: function (item) {
			let label = item.name;
			item.mode == 0 ? label = label+'(%)' : '';
			return label;
		},
		fn_checkFields: function(doneAndNew){
			if(this.$refs['ref_componentDynamicFields'] && this.$refs['ref_componentDynamicFields'].length){
				this.$refs['ref_componentDynamicFields'][0].$validator.validateAll('fields').then((result) => {
					if(result){
						this.fn_checkValidations(doneAndNew);
					}
				})
			}
			else{
				this.fn_checkValidations(doneAndNew);
			}
		},
		fn_checkValidations: function(doneAndNew){
			this.disableBtn = true;

			console.log('shsd')

			// if(this.$parent.fn_isNewTaxForm() && !localStorage.getItem('hide_old_tax_message')){
			// 	let taxPer = this.$parent.Form.productData.items[0].taxValue;
			// 	if(taxPer != 5 && taxPer != 18 && taxPer != 40 && taxPer != 3 && taxPer != 0.25 && taxPer != 1.5){
			// 		// this.$parent.snackbarTaxCategory = true;
			// 		this.$parent.fn_openDialogWeb('web', 'OldTaxUpdate', 'ref_dialogOldTaxUpdate');
			// 		this.disableBtn = false;
			// 		return;
			// 	}
			// }
			
			this.$validator.validateAll('fields').then((result) => {
				if (result) {

					for(let i=0; i<this.$parent.Form.productData.items.length; i++){

						let product = this.$parent.Form.productData.items[i];

						let quantityFilled = false;

						for(let i=0; i<product.productVariants.length; i++){
							// if(product.productVariants[i].qty){
							// 	quantityFilled = true;
							// 	break;
							// }
							if(!product.productVariants[i].qty){
								product.productVariants[i].qty = '1';
							}
						}

						// if(!quantityFilled){
						// 	self.showToast("Please add quantity");
						// 	self.disableBtn = false;
						// 	// self.hideLoading();
						// 	return;
						// }
						// else if(self.netAmount<0){
						if(product.netAmount<0){
							this.showToast("Net Amount cannot be negative");
							this.disableBtn = false;
							// self.hideLoading();	
							return;
						}

						// validating if batch total qty is greater than item qty added in bill
						if(this.$parent.Form.productData.items[0].baseTransactionListId != this.$parent.Form.transactionData.transactionListId){
							if(this.$parent.Form.productData.items[0].batches && this.$parent.Form.productData.items[0].batches.length){
								let batchTotal = 0;
								let billTotal = 0;
								for(let i=0; i<this.$parent.Form.productData.items[0].batches.length; i++){
									batchTotal = batchTotal + Number(this.$parent.Form.productData.items[0].batches[i].productQty);
									billTotal = billTotal + Number(this.$parent.Form.productData.items[0].batches[i].billQty);
								}
								if(billTotal < batchTotal){
									this.showToast("Batch quantity should be less then or equal to bill quantity");
									this.disableBtn = false;
									return
								}
							}
							else{
								if(!this.fn_checkInput(product.productVariants[0], true)){
									// this.showToast("Quantity should be less then or equal to bill quantity");
									this.disableBtn = false;
									return
								}
								// if(product.productVariants[0].qty > product.productVariants[0].billQty){
								// 	this.showToast("Quantity should be less then or equal to bill quantity");
								// 	this.disableBtn = false;
								// 	return
								// }
							}							
						}

						// if(this.$parent.Form.productData.items[0].batches && this.$parent.Form.productData.items[0].batches.length){
						// 	let totalBatchQty = 0;
						// 	let bat = null;
						// 	if(this.$parent.Form.selectedBatchType == 2){
						// 		bat = this.$parent.Form.productData.items[0].batches.filter(field=>{
						// 			return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.opening && !field.field4
						// 		})

						// 		this.$parent.Form.productData.items[0].batches = this.$parent.Form.productData.items[0].batches.filter(field=>{
						// 			return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.opening && !field.field4
						// 		})
						// 	}
						// 	else{
						// 		bat = this.$parent.Form.productData.items[0].batches.filter(field=>{
						// 			return !field.field1 && !field.field2 && !field.field3
						// 		})

						// 		this.$parent.Form.productData.items[0].batches = this.$parent.Form.productData.items[0].batches.filter(field=>{
						// 			return !field.field1 && !field.field2 && !field.field3
						// 		})
						// 	}
						// 	for(let i=0;i<bat.length;i++){
						// 		totalBatchQty += Number(bat[i].productQty);
						// 	}
						// 	if(product.productVariants[0].qty != totalBatchQty){
						// 		this.showToast("Product quantity not matched with batch quantity");
						// 		this.disableBtn = false;
						// 		return;
						// 	}
						// }
					}

					for(let i=0; i<this.$parent.Form.productData.items.length; i++){

						let product = this.$parent.Form.productData.items[i];

						let self = this;

						(function(product, index){
							product.productId = self.$parent.Form.productData.productId;
							product.productName = self.$parent.Form.productData.productName;
							// product.netAmount = self.netAmount;

							if(product.fromScanner){
								setTimeout(() => {
									self.$parent.fn_closeDialog();
									self.$parent.fn_openDialogBarcode(product);
								}, 100);
							}
							else{
								self.saveItem(product, index, self.$parent.Form.productData.items.length, doneAndNew);
							}
						}(product, i));

					}
					
				}
				else{
					this.disableBtn = false;
					// this.hideLoading();	
				}
			});
			
		},
		// fn_checkValidations: function(){

		// 	this.$validator.validateAll('fields').then((result) => {
		//         if (result) {
		//         	this.$parent.Form.productDataModel.netAmount = this.netAmount;
		//         	let quantityFilled = false;

		//         	for(let i=0; i<this.$parent.Form.productDataModel.productVariants.length; i++){
		//         		if(this.$parent.Form.productDataModel.productVariants[i].qty){
		//         			quantityFilled = true;
		//         			break;
		//         		}
		//         	}

		//         	if(!quantityFilled){
		//         		this.showToast("Please add quantity");
		//         		this.disableBtn = false;
		//         	}
		//         	else if(this.netAmount<0){
		//         		this.showToast("Amount cannot be negative");
		//         		this.disableBtn = false;
		//         	}
		//         	else{
		//         		this.saveItem(this.$parent.Form.productDataModel);
		//         	}
		           	
		//         }
		//         else{
		//         	this.disableBtn = false;
		//         }
		//     });
		// },
		fn_checkPercentage: function (item) {
			!item.percentage ? item.value = null : '';
		},

		fn_computeValues: function (productData) {
			let grossAmount = 0;
			let grossAmountAsPerMRP = 0;

			let netValue = 0;

			let self = this;

			//Calculating gross amount
			productData.productVariants.forEach(function (item) {
				let packQty = 1;
				let qty = 1;
				let rate = productData.rate;

				// item.packQuantity ? packQty = item.packQuantity : '';

				item.qty ? qty = item.qty : '';

				//calculation as per rate
				if(!qty || !rate)
					grossAmount += 0;
				else{
					grossAmount += qty * packQty * rate;
				}

				//calculation as per mrp
				let mrp = productData.mrp;
				if(!qty || !mrp)
					grossAmountAsPerMRP += 0;
				else{
					grossAmountAsPerMRP += qty * packQty * mrp;
				}
			})

			// productData.productVariants.forEach(function (item) {
			// 	let packQty = 1;
			// 	let rate = productData.rate;

			// 	item.packQuantity ? packQty = item.packQuantity : '';

			// 	//calculation as per rate
			// 	if(!item.qty || !rate)
			// 		grossAmount += 0;
			// 	else{
			// 		grossAmount += item.qty * packQty * rate;
			// 	}

			// 	//calculation as per mrp
			// 	let mrp = productData.mrp;
			// 	if(!item.qty || !mrp)
			// 		grossAmountAsPerMRP += 0;
			// 	else{
			// 		grossAmountAsPerMRP += item.qty * packQty * mrp;
			// 	}
			// })

			productData.grossAmount = this.roundUpto2Decimals(grossAmount);
			productData.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);

			grossAmount = this.roundUpto2Decimals(grossAmount);
			grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);
			netValue = this.roundUpto2Decimals(grossAmount);

			//calculating addons
			let mrp = productData.mrp ? productData.mrp : 0;
			let addOnsTotalValue = 0;

			productData.addOnsItems.forEach(function (item) {

				let applicableAmount = 0;
				let addOnsValue = 0;

				//on net value
				if(item.appliedOn == 0){
					applicableAmount = netValue;
				}//value of goods
				else if(item.appliedOn == 1){
					applicableAmount = grossAmount;
				}//on mrp
				//this condition will not work as MRP field is disabled in dialog_addons (global)
				else{
					applicableAmount = grossAmountAsPerMRP;
				}

				//Caculating addOns except gst's
				if(!item.isGst){
					//of value or percentage
					if(item.mode){//value
						addOnsValue = item.value;
					}
					else{//percentage
						if(item.percentage){
							addOnsValue = (applicableAmount*item.percentage)/100;
							item.value = self.roundUpto2Decimals(addOnsValue);
						}
						else if(item.value){
							addOnsValue = item.value;
						}
					}
				}
				

				addOnsValue = self.roundUpto2Decimals(addOnsValue);

				//Final calculation
				if(item.adjustInTotal){
					if(item.nature==0){
						netValue = netValue + addOnsValue;
					}
					else{
						netValue = netValue - addOnsValue;
					}
				}				

			});

			//Tax will only affect net amount in case of exclusive tax where this.$parent.Form.taxMode == 1

			let itemTaxAmount = 0;
			let addibleTax = 0;
			let itemCessAmount = 0;

			let itemCessAmountOnQty = 0;
			if(this.$parent.Form.taxMode){

				let taxTotalPercent = productData.taxValue;
				if(productData.isCessApplicable){
					taxTotalPercent = taxTotalPercent + productData.cessValue;
				}

				let taxAmountInclusive = null;

				if(productData.taxValue && self.$parent.Form.taxMode==2){
					let itemNetValue = netValue;
					if(productData.isCessApplicable && productData.cessValueOnQuantity){
						let qtyCessAmount = productData.productVariants[0].qty * productData.cessValueOnQuantity;
						itemNetValue  = itemNetValue - qtyCessAmount;
						itemNetValue < 0 ? itemNetValue = 0 : '';
					}

					let taxPer = productData.taxValue / self.$parent.Form.gstAddOns.length;
					taxAmountInclusive = (itemNetValue * taxPer)/(100+taxTotalPercent);
				}
				
				this.$parent.Form.gstAddOns.forEach(function (item) {

					if(productData.taxValue){
						let gstCategoriesLength = self.$parent.Form.gstAddOns.length;

						let percentage = productData.taxValue / gstCategoriesLength;

						item.percentage = percentage;

						//exclusive tax
						if(self.$parent.Form.taxMode==1){
							let taxAmount = (netValue * item.percentage)/100;
							item.value = self.roundUpto2Decimals(taxAmount);
							addibleTax += item.value ? item.value : 0;
							itemTaxAmount += item.value;
						}
						//inclusive tax
						else if(self.$parent.Form.taxMode==2){
							// item.value = self.roundUpto2Decimals(taxAmountInclusive/gstCategoriesLength);
							item.value = self.roundUpto2Decimals(taxAmountInclusive);
							itemTaxAmount += item.value;
						}
					}

				});

				//Calculation of cess

				if(productData.isCessApplicable){

					this.$parent.Form.cessAddOns.percentage = productData.cessValue;

					//exclusive tax
					if(self.$parent.Form.taxMode==1){
						if(productData.cessValue != undefined){
							if(productData.cessValue!=null){
								let cessAmount = (netValue * this.$parent.Form.cessAddOns.percentage)/100;
								this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmount);
								addibleTax += this.$parent.Form.cessAddOns.value ? this.$parent.Form.cessAddOns.value : 0;	
								itemCessAmount = this.$parent.Form.cessAddOns.value;
							}
							else{
								this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(productData.cessAmount);
								addibleTax += productData.cessAmount ? productData.cessAmount : 0;	
								itemCessAmount = productData.cessAmount;
							}
						}
						

						if(productData.cessValueOnQuantity!=undefined){
							if(productData.cessValueOnQuantity!=null){
								// this.$parent.Form.cessAddOns.percentageOnQty = productData.cessValueOnQuantity;
								let cessAmountOnQty = productData.productVariants[0].qty * productData.cessValueOnQuantity;
								this.$parent.Form.cessAddOns.valueOnQty = self.roundUpto2Decimals(cessAmountOnQty);
								addibleTax += this.$parent.Form.cessAddOns.valueOnQty ? this.$parent.Form.cessAddOns.valueOnQty : 0;	
								itemCessAmountOnQty = this.$parent.Form.cessAddOns.valueOnQty;
							}
							// else{
							// 	this.$parent.Form.cessAddOns.valueOnQty = self.roundUpto2Decimals(productData.cessAmountOnQty);
							// 	addibleTax += productData.cessAmountOnQty ? productData.cessAmountOnQty : 0;	
							// 	itemCessAmountOnQty = productData.cessAmountOnQty;
							// }
						}
						
					}
					//inclusive tax
					else if(self.$parent.Form.taxMode==2){

						if(productData.cessValue != undefined){
							if(productData.cessValue!=null){
								let itemNetValue = netValue;
								if(productData.isCessApplicable && productData.cessValueOnQuantity){
									let qtyCessAmount = productData.productVariants[0].qty * productData.cessValueOnQuantity;
									itemNetValue  = itemNetValue - qtyCessAmount;
									itemNetValue < 0 ? itemNetValue = 0 : '';
								}

								let cessAmountInclusive = (itemNetValue * productData.cessValue)/(100+taxTotalPercent);
								this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmountInclusive);
								itemCessAmount = this.$parent.Form.cessAddOns.value;
							}
							else{
								this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(productData.cessAmount);
								itemCessAmount = productData.cessAmount;
							}
						}

						if(productData.cessValueOnQuantity != undefined){
							if(productData.cessValueOnQuantity!=null){
								let cessAmountOnQtyInclusive = productData.productVariants[0].qty * productData.cessValueOnQuantity;
								this.$parent.Form.cessAddOns.valueOnQty = self.roundUpto2Decimals(cessAmountOnQtyInclusive);
								itemCessAmountOnQty = this.$parent.Form.cessAddOns.valueOnQty;
							}
							// else{
							// 	this.$parent.Form.cessAddOns.valueOnQty = self.roundUpto2Decimals(productData.cessAmountOnQty);
							// 	itemCessAmountOnQty = productData.cessAmountOnQty;
							// }
						}
						// if(productData.cessValue!=null){
						// 	let cessAmountInclusive = (netValue * productData.cessValue)/(100+productData.cessValue);
						// 	this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmountInclusive);
						// 	itemCessAmount = this.$parent.Form.cessAddOns.value;
						// }
						// else{
						// 	this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(productData.cessAmount);
						// 	itemCessAmount = productData.cessAmount;
						// }

					}

				}
			}

			productData.taxAmount = self.roundUpto2Decimals(itemTaxAmount);
			productData.cessAmount = self.roundUpto2Decimals(itemCessAmount);
			productData.cessAmountOnQty = self.roundUpto2Decimals(itemCessAmountOnQty);

			if(productData.cessValue==null && itemCessAmount===''){
				productData.cessAmount = null;
			}

			if(productData.itemCessAmountOnQty==null && itemCessAmountOnQty===''){
				productData.itemCessAmountOnQty = null;
			}

			//Taxable amount is net value after deduction of addons on which tax(gst) will apply
			//taxable value in case of exclusive tax
			productData.taxableValue = this.roundUpto2Decimals(netValue);

			//Gross amount in case of inclusive tax
			if(self.$parent.Form.taxMode==2){
				// productData.grossAmount = this.roundUpto2Decimals(grossAmount - itemTaxAmount - itemCessAmount);
				productData.grossAmount = this.roundUpto2Decimals(grossAmount - itemTaxAmount - itemCessAmount - itemCessAmountOnQty);
				// productData.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP - itemTaxAmount - itemCessAmount);
				productData.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP - itemTaxAmount - itemCessAmount - itemCessAmountOnQty);
				//taxable value in case of inclusive tax
				// productData.taxableValue = this.roundUpto2Decimals(netValue - itemTaxAmount - itemCessAmount);
				productData.taxableValue = this.roundUpto2Decimals(netValue - itemTaxAmount - itemCessAmount - itemCessAmountOnQty);
			}

			//calculating net amount after default tax
			netValue = netValue + addibleTax;


			return this.roundUpto2Decimals(netValue);
		},

		fn_removeBatch: function(batchIndex){
			this.$parent.Form.productData.items[0].batches.splice(batchIndex, 1);
			let totalQty = 0;
			for(let i=0; i<this.$parent.Form.productData.items[0].batches.length; i++){
				totalQty = totalQty + Number(this.$parent.Form.productData.items[0].batches[i].productQty);
			}
			this.$parent.Form.productData.items[0].productVariants[0].qty = totalQty ? totalQty : null;
			// this.$forceUpdate();
		},

		fn_unitChange: function(value, item, product){
			if(!this.dialogJustOpen){
				let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
				if(currentItemId != value.itemId){
					if(value.itemId == item.secondaryUnitId){
						product.rate = (product.rate * item.packQuantity) / item.secondaryUnitPackQuantity;
					}
					else{
						product.rate = (product.rate * item.secondaryUnitPackQuantity) / item.packQuantity;
						// product.rate = this.roundUpto2Decimals(product.rate * item.secondaryUnitPackQuantity);
					}
					product.rate = this.roundUpto2Decimals(product.rate); 

					if(item.billQty != undefined){
						this.fn_checkAndUpdateBillQty(value, item, product);
					}
				}
				
				this.fn_checkInput(item);
			}
		},

		fn_checkAndUpdateBillQty: function(value, item, product){
			if(item.secondaryUnitId){
				if(value.itemId == item.secondaryUnitId){
					item.billQty = Math.round(this.roundUpto2Decimals((item.billQty * item.secondaryUnitPackQuantity) / item.packQuantity));
					if(product.batches && product.batches.length){
						for(let i=0; i<product.batches.length; i++){
							if(product.batches[i].billQty!=undefined){
								product.batches[i].billQty = Math.round(this.roundUpto2Decimals((product.batches[i].billQty * item.secondaryUnitPackQuantity) / item.packQuantity));
							}
						}
					}
				}
				else{
					item.billQty = this.roundUpto2Decimals((item.billQty * item.packQuantity) / item.secondaryUnitPackQuantity);
					if(product.batches && product.batches.length){
						for(let i=0; i<product.batches.length; i++){
							if(product.batches[i].billQty!=undefined){
								product.batches[i].billQty = this.roundUpto2Decimals((product.batches[i].billQty * item.packQuantity) / item.secondaryUnitPackQuantity);
							}
						}
					}
				}
			}
		},

		getSummaryQuantity: function(item){
			if(this.summaryArray && this.summaryArray.length){
				if(!item.selectedUnit || item.selectedUnit && item.selectedUnit.itemId == item.primaryUnitId){
					return this.summaryArray[0].qty;
				}
				else{
					return (this.summaryArray[0].qty * item.secondaryUnitPackQuantity) / item.packQuantity;
				}
			}
		},

		fn_changeBatchType: function(val, product){
			if(val==2 && this.$parent.Form.productData.items[0].batches && this.$parent.Form.productData.items[0].batches.length){
				if(product.productVariants[0].selectedUnit){
					product.productVariants[0].selectedUnit = {"itemId":product.productVariants[0].primaryUnitId, "itemName":product.productVariants[0].primaryUnitName}
				}
			}
		},

		fn_getPartyWiseRate: function(productData){
			var self = this;
			let filterObj = {};
			filterObj.partyId = this.$parent.Form.partyId;
			filterObj.productId = productData.productId;
			this.getFilterData('GetPartyWiseProductRate', null, filterObj, 
				{
					onSuccess: function(response){
						console.log('partywise rate');
						console.log(response);
						if(response){
							let data = JSON.parse(response);
							self.$parent.Form.partyWiseItemRate = data.rate
							self.$parent.Form.productData.items[0].rate = data.rate;
						}
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		}

		// fn_assignTempValue: function(val){
		// 	this.tempRate = val;
		// }

	},
	computed:{
		netTotal: function () {
			let netTotal = 0;
			let self = this;
			for(let i=0; i<this.$parent.Form.productData.items.length; i++){
				(function(i){
					self.$parent.Form.productData.items[i].netAmount = self.fn_computeValues(self.$parent.Form.productData.items[i]);
					netTotal += self.$parent.Form.productData.items[i].netAmount;
				}(i));
			}
			return netTotal;
			// return this.fn_computeValues(this.$parent.Form.productDataModel);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/sale/dialogs/dialog_product.vue